// extracted by mini-css-extract-plugin
module.exports = {"markWrap":"Mark_markWrap__dqwrz","mark":"Mark_mark__3wQr-","markHover":"Mark_markHover__I7jOi","markName":"Mark_markName__n5bOC"};